"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataCy = exports.ToggleButtonGroup = void 0;
var _react = require("react");
var _FormControl = require("@mui/material/FormControl");
var _ToggleButton = _interopRequireDefault(require("@mui/material/ToggleButton"));
var _ToggleButtonGroup = _interopRequireDefault(require("@mui/material/ToggleButtonGroup"));
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["outlinedError", "fullWidthClass"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    outlinedError: {
      '& > button': {
        borderColor: theme.palette.error.main
      }
    }
  };
});
var defaultGetOptionValue = function defaultGetOptionValue(_ref) {
  var id = _ref.id;
  return id;
};
var defaultGetOptionLabel = function defaultGetOptionLabel(_ref2) {
  var name = _ref2.name;
  return name;
};
var EMPTY_OPTIONS = [];
var dataCy = exports.dataCy = 'ToggleButtonGroup';
var ToggleButtonGroup = exports.ToggleButtonGroup = function ToggleButtonGroup(_ref3) {
  var children = _ref3.children,
    _ref3$options = _ref3.options,
    options = _ref3$options === void 0 ? EMPTY_OPTIONS : _ref3$options,
    _ref3$getOptionValue = _ref3.getOptionValue,
    getOptionValue = _ref3$getOptionValue === void 0 ? defaultGetOptionValue : _ref3$getOptionValue,
    _ref3$getOptionLabel = _ref3.getOptionLabel,
    getOptionLabel = _ref3$getOptionLabel === void 0 ? defaultGetOptionLabel : _ref3$getOptionLabel,
    onChange = _ref3.onChange,
    value = _ref3.value,
    _ref3$exclusive = _ref3.exclusive,
    exclusive = _ref3$exclusive === void 0 ? true : _ref3$exclusive,
    _ref3$color = _ref3.color,
    color = _ref3$color === void 0 ? 'primary' : _ref3$color,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'small' : _ref3$size,
    fullWidth = _ref3.fullWidth,
    className = _ref3.className,
    _ref3$enforceValue = _ref3.enforceValue,
    enforceValue = _ref3$enforceValue === void 0 ? false : _ref3$enforceValue,
    _ref3$disabled = _ref3.disabled,
    disabled = _ref3$disabled === void 0 ? false : _ref3$disabled;
  var formControl = (0, _FormControl.useFormControl)();
  var _useStyles = useStyles(),
    outlinedError = _useStyles.outlinedError,
    fullWidthClass = _useStyles.fullWidthClass,
    classes = _objectWithoutProperties(_useStyles, _excluded);
  var handleChange = (0, _react.useCallback)(function (e, v) {
    if (!enforceValue) {
      if (v === null || v === undefined) {
        return;
      }
    }
    onChange(e, v);
  }, [onChange, enforceValue]);
  var buttons = options && options.length ? options.map(function (option) {
    var buttonValue = getOptionValue(option);
    var label = getOptionLabel(option);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToggleButton["default"], {
      value: buttonValue,
      children: label
    }, buttonValue);
  }) : children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToggleButtonGroup["default"], {
    "data-cy": dataCy,
    exclusive: exclusive,
    classes: _objectSpread({
      root: formControl !== null && formControl !== void 0 && formControl.error ? outlinedError : undefined
    }, classes),
    className: className,
    disabeld: formControl === null || formControl === void 0 ? void 0 : formControl.formControl,
    onChange: handleChange,
    value: value,
    size: size,
    color: color,
    disabled: disabled,
    fullWidth: fullWidth,
    children: buttons
  });
};